<template>
  <div>
    <my-header></my-header>

    <div class="content-container-level-1">
      <table class="m3-props-table mb-2">
        <tr>
          <td>
            Последовательность
          </td>
          <td>
            <router-link :to="{name: 'sequence_levels', params: {sequence_id: sequenceProtoId}, query: sequenceQuery}">
              {{sequenceProtoId | getProtoAlias}}
            </router-link>
          </td>
        </tr>
        <tr>
          <td>Номер уровня</td>
          <td>{{levelNumber}}</td>
        </tr>
        <tr>
          <td>Вариант уровня</td>
          <td>
            <level-var-link
              :levelVarId="revisionId"
              :audienceId="audienceId | zeroToNull"
            >
              {{levelVarName}}
            </level-var-link>
          </td>
        </tr>
        <tr>
          <td>Ревизия</td>
          <td>{{revisionNumber}}</td>
        </tr>
      </table>

      <template v-if="revision !== null">
        <table class="m3-props-table mb-4">
          <tr>
            <td>Ходы</td>
            <td>{{revision.turnsLimit}}</td>
          </tr>
          <tr>
            <td>Сложность</td>
            <td>{{revision.difficulty | getDifficultyName}}</td>
          </tr>
          <tr>
            <td>Регистрация</td>
            <td>{{revision.deployedAt | getMomentStr}}</td>
          </tr>
          <tr>
            <td>Состояние</td>
            <td :class="revision.state | getRevisionStateClass">
              {{revision.state | getRevisionStateName}}
            </td>
          </tr>
        </table>

        <seeds-view
          :seeds="seeds"
        />

        <!--
        <h2>Статистика</h2>
        <table class="m3-props-table">
          <tr>
          <td>Аудитория</td>
          <td>{{audienceId | getAudienceName}}</td>
        </tr>
        </table>
        -->

      </template>

      <loading-indicator
        v-if="isLoading"
      />
    </div>
  </div>
</template>

<script>
import notifier from '../../notifier.js';
import { HTTP } from '../../http-common.js';

import { getLevelVarName                  } from '../../model/m3level.js';
import { getDifficultyName                } from '../../model/m3level.js';
import { getRevisionStateName             } from '../../model/m3level.js';
import { getAudienceName                  } from '../../model/m3level.js';
import { getRevisionStateClass            } from '../../model/m3level.js';
import { convertRevisionIdToLevelIDObj    } from '../../model/m3level.js';
import { convertOptionalValueToQueryParam } from '../../util.js';
import { zeroToNull                       } from '../../util.js';

import MyHeader from '../Header.vue';
import LoadingIndicator from '../LoadingIndicator.vue';
import LevelVarLink from './LevelVarLink.vue';
import SeedsView from './SeedsView.vue';

const LOAD_STATE_INIT          = 1;
const LOAD_STATE_LOADING       = 2;
const LOAD_STATE_LOADED_NORMAL = 3;
const LOAD_STATE_LOADED_ERROR  = 4;

export default {
  name: 'Revision',

  components: {
    MyHeader,
    LoadingIndicator,
    LevelVarLink,
    SeedsView,
  },

  props: {
    revisionId: {
      type: Object,
      required: true,
    },

    audienceId: {
      type: Number,
      default: null,
    },
  },

  data() {
    return {
      loadState: LOAD_STATE_INIT,
      revision: null,
    };
  },

  computed: {
    sequenceProtoId() {
      return this.revisionId.sequenceProtoId;
    },

    levelNumber() {
      return this.revisionId.number;
    },

    levelProtoId() {
      return this.revisionId.protoId;
    },

    levelVarName() {
      return getLevelVarName(this.levelProtoId);
    },

    revisionNumber() {
      return this.revisionId.revision;
    },

    seeds() {
      return this.revision.seeds;
    },

    sequenceQuery() {
      return {
        audience: convertOptionalValueToQueryParam(this.audienceId),
      };
    },

    isLoading() {
      return this.loadState === LOAD_STATE_LOADING;
    },

    isLoadedNormal() {
      return this.loadState === LOAD_STATE_LOADED_NORMAL;
    },
  },

  created() {
    this.loadRevisionSegment();
  },

  methods: {
    loadRevisionSegment() {
      notifier.deleteSenderNotifications(this);

      this.loadState = LOAD_STATE_LOADING;

      const url = `/m3/sequences/${this.sequenceProtoId}/levels/${this.levelNumber}/${this.levelProtoId}/revision/${this.revisionNumber}`;

      var requestConfig = null;
      if(this.audienceId !== null) {
        requestConfig = {
          params: {
            audience: this.audienceId,
          }
        };
      }

      HTTP.get(url, requestConfig)
      .then(response => {
        this.revision = response.data.data;
        this.loadState = LOAD_STATE_LOADED_NORMAL;
      })
      .catch(e => {
        this.loadState = LOAD_STATE_LOADED_ERROR;
        notifier.showError(e.response.data, {sender: this});
      });
    },
  },

  filters: {
    getAudienceName,
    getRevisionStateName,
    getDifficultyName,
    getRevisionStateClass,
    zeroToNull,
    convertRevisionIdToLevelIDObj,
  },
}
</script>

<style scoped>
.m3-props-table td:first-child {
  padding-right: .5rem;
}
</style>
